/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 16.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import DataProvider from "../../../DataProvider";
import DataWidget from "../DataWidget";

/**
 * Show specified fields together in one line.
 * Specify in UI Schema as follows:
 *  {
 *      "ui:widget": "tuple",
 *      "ui:options": {
 *          "joinExpr": [joinExpr, ...],
 *          "fields": [field, ...]
 *      }
 *  }
 *
 */
class ViewTuple extends React.Component {
    static propTypes = {
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
        field: PropTypes.string
    };

    static defaultProps = {
        field: null
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    renderItems() {
        let items = [];
        /**
         * @type {DataProvider}
         */
        let dataProvider = this.props.dataProvider;

        let schema = dataProvider.getSchema();
        let parentField = this.props.field;
        if (parentField) {
            schema = schema.field(parentField);
            parentField += "/";
        }
        else parentField = "";
        let options = schema.getSchemaElement("options");
        if (!options) options = {};

        let joinExpr = options.joinExpr || [];
        let fieldList = options.fields;
        if (!fieldList) return null;
        if (!_.isArray(fieldList)) fieldList = [fieldList];
        if (_.isArray(joinExpr)) joinExpr = joinExpr.slice(0);
        else joinExpr = [joinExpr];
        if (joinExpr.length < 1) joinExpr = [" "];

        let isFirst = true;
        for (let f of fieldList) {
            if (isFirst) isFirst = false;
            else {
                items.push(joinExpr[0]);
                if (joinExpr.length > 1) joinExpr.shift();
            }

            let field = parentField + f;
            if (dataProvider.getValue(field) == null) continue;

            items.push((<DataWidget key={field} dataProvider={dataProvider} field={field} />));
        }
        return items;
    }

    render() {
        return (
            <span>
                {this.renderItems()}
            </span>
        );
    }
}

export default ViewTuple;
